"use client";

import { ArrowUp } from "lucide-react";
import { useMemo } from "react";

import Sidebar from "@/components/shared/sidebar";
import { createClient } from "@/lib/supabase/client";

const chips = [
  "Start blank",
  "Use template",
  "Import questions",
  "Surprise me",
] as const;

const suggestions = [
  "Job application form",
  "Event registration",
  "Customer onboarding",
] as const;

export default function DashboardPage() {
  const supabase = useMemo(() => createClient(), []);
  void supabase;

  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <div className="ml-16 flex min-h-screen flex-1 justify-center bg-[#F7F6F3] px-4 py-10 dark:bg-[#1C1917] sm:px-8 sm:py-12">
        <div className="flex w-full max-w-3xl flex-col items-center justify-center">
          <h1 className="font-display text-center text-3xl leading-tight font-medium tracking-tight text-[#1C1917] sm:text-4xl md:text-[2.5rem] dark:text-[#F7F6F3]">
            What kind of form do you want to build?
          </h1>
          <p className="mt-4 max-w-xl text-center text-base text-[#6f6862] sm:text-lg dark:text-[#6f6862]">
            Describe it and AI will do the rest.
          </p>

          <div className="mt-10 w-full">
            <div className="overflow-hidden rounded-lg border border-[#E7E5E0] bg-[#FFFFFF] shadow-sm dark:border-white/10 dark:bg-[#2C2925]">
              <label htmlFor="form-prompt" className="sr-only">
                Describe your form
              </label>
              <textarea
                id="form-prompt"
                placeholder="e.g. A customer feedback form for a SaaS product..."
                rows={4}
                className="min-h-[120px] w-full resize-none border-0 bg-transparent px-4 pt-4 pb-2 text-[#1C1917] text-base placeholder:text-[#6f6862]/80 focus:ring-0 sm:min-h-[140px] dark:text-[#F7F6F3]"
              />

              <div className="flex flex-col gap-3 border-t border-[#E7E5E0] px-3 py-3 sm:flex-row sm:items-center sm:justify-between sm:gap-2 sm:px-4 dark:border-white/10">
                <div className="flex flex-wrap gap-2">
                  {chips.map((label) => (
                    <button
                      key={label}
                      type="button"
                      className="cursor-pointer rounded-full border border-[#E7E5E0] bg-[#F7F6F3] px-3 py-1.5 text-xs font-medium text-[#6f6862] transition-colors hover:border-[#1C1917]/15 hover:text-[#1C1917] sm:text-sm dark:bg-transparent dark:border-white/20 dark:text-white/70 dark:hover:bg-white/10"
                    >
                      {label}
                    </button>
                  ))}
                </div>
                <button
                  type="button"
                  className="flex h-10 shrink-0 cursor-pointer items-center justify-center gap-1.5 self-end rounded-lg bg-[#E94B1C] px-4 text-sm font-semibold text-[#FFFFFF] transition-opacity hover:opacity-90 sm:self-auto"
                >
                  Send
                  <ArrowUp aria-hidden className="size-4" strokeWidth={2.25} />
                </button>
              </div>
            </div>

            <div className="mt-6 flex flex-col items-center gap-2 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-3">
              {suggestions.map((s) => (
                <button
                  key={s}
                  type="button"
                  className="cursor-pointer rounded-full border border-[#E7E5E0] bg-transparent px-4 py-2 text-sm text-[#6f6862] transition-colors hover:border-[#6f6862]/40 hover:text-[#1C1917] dark:border-white/10 dark:text-[#F7F6F3]/60"
                >
                  {s}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
